<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import Fraction from './functions/fractionClass';
	import Surd from './functions/surdClass';
	import Chart from './Chart.svelte';

	export let uqn: number;

	let ansA: string, ansB: string, ansC: string;
	$: [ansA, ansB, ansC] = uqnToQn(uqn);

	function uqnToQn(u:number):string[]{
		let [t,a,s] = uqnSplit(u);
		let ans1: string, ans2: string, ans3:string;
		const surdAns = new Surd(a,3);
		if (t==1 || t==2){
			ans1 = "a";
		} else{
			ans1 = "b"
		}
		ans1 += "=0, " + surdAns.toString() + ", \\textrm{ or } -" + surdAns.toString();
		const n = Math.ceil((Math.log(1000))/(Math.log(2*a)));
		ans2 = "\\textrm{Smallest } n =" + n.toString();
		ans3 = "\\left|z^n\\right|=" + Math.pow(2*a,n).toString() + ",\\; \\textrm{arg}(z^n)=";
		let angleAns: string;
		if (t==1 || t==2){ // \sqrt{3} \pm i
			let num = 1; // representing pi/6
			if (s==1){
				num = 11; // representing 11pi/6
			}
			num = (num*n)%12;
			if (num>6){
				num = -(12-num)
			}
			const angle = new Fraction(num,6);
			angle.simplify();
			angleAns = angle.toString() + "\\pi";
			if (angle.num==0){
				angleAns = "0";
			} else if (angle.num==1 && angle.den==1){
				angleAns = "\\pi"
			}
		} else{ // \pm 1 + \sqrt{3}
		let num = 1; // representing pi/3
			if (s==1){
				num = 2; // representing 2pi/3
			}
			num = (num*n)%6;
			if (num>3){
				num = -(6-num);
			}
			const angle = new Fraction(num,3);
			angle.simplify();
			angleAns = angle.toString() + "\\pi";
			if (angle.num==0){
				angleAns = "0";
			} else if (angle.num==1 && angle.den==1){
				angleAns = "\\pi"
			}
		}
		ans3 += angleAns;
		return [ans1,ans2,ans3];
	}
</script>

<p>
	(a) <Katex math={ansA}/>
</p>
<p>
	(b) <Katex math={ansB}/>
</p>
<p>
	(c) <Katex math={ansC}/>
</p>
<p>
	(d) <Chart uqn={uqn}/>
</p>
